<template>
  <div class="wrapper">
    <h3 style="font-size: 20px; font-weight: 500;" class="text-xs-center mb-3">
      {{ $t('registration_id') }}: {{ registrationId }}
    </h3>
    <v-form @submit.prevent="onSubmit">
      <v-layout class="form-wrapper" justify-center wrap>
        <v-flex v-for="file in selectedFiles" :key="file.name" class="text-xs-center" xs12>
          <strong>{{ file.name }}</strong>
        </v-flex>
        <v-btn color="primary" class="primary-btn" @click="selectFiles">{{ $t('choose_files') }}</v-btn>
      </v-layout>
      <input
        ref="fileInput"
        :accept="allowedFileFormats"
        type="file"
        multiple
        @change="onFileChange">
      <v-btn v-if="selectedFiles.length" type="submit" color="primary" class="primary-btn" @click="onSubmit">
        {{ $t('confirm') }}
      </v-btn>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'FilePicker',

  data() {
    return {
      allowedFileFormats: 'application/pdf',
    };
  },

  computed: {
    ...mapState({
      registrationId: state => state.documents.registrationId,
      selectedFiles: state => state.documents.selectedFiles,
    }),
  },

  methods: {
    ...mapMutations({
      setSelectedFiles: 'documents/setFiles',
    }),

    onSubmit() {
      this.$router.push({ name: 'agreements' });
    },

    selectFiles() {
      this.$refs.fileInput.click();
    },

    onFileChange(event) {
      let files;
      if (event && event.target) {
        files = event.target.files || event.dataTransfer.files;
      } else if (event) {
        files = [event];
      }
      this.setSelectedFiles(files);
    },
  },
};
</script>

<style scoped>
  input[type=file] {
    display: none;
  }
</style>
